import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useParams, Link } from "react-router-dom";

export default function BeritaDetail() {
  const { id } = useParams();
  const [berita, setBerita] = useState(null);

  useEffect(() => {
    const fetchBerita = async () => {
      const ref = doc(db, "berita", id);
      const snap = await getDoc(ref);
      if (snap.exists()) setBerita(snap.data());
    };
    fetchBerita();
  }, [id]);

  if (!berita) return <p className="text-center mt-5">Memuat berita...</p>;

  return (
    <section className="berita-detail-section py-5">
      <div className="container">
        <Link to="/informasi/berita" className="btn btn-outline-primary mb-4">
          &larr; Kembali ke daftar berita
        </Link>
        <h2 className="fw-bold mb-3">{berita.judul}</h2>
        <p className="text-muted mb-3">{new Date(berita.tanggal).toLocaleDateString()}</p>
        {berita.gambar && (
          <img
            src={berita.gambar}
            alt={berita.judul}
            className="mb-4 w-100 rounded"
            style={{ maxHeight: "400px", objectFit: "cover" }}
          />
        )}
        <p className="text-secondary">{berita.deskripsi}</p>
      </div>
    </section>
  );
}
